import _ from 'lodash';
import type { ThemeTreeType } from 'types/index.d';

/****
 * ThemeTreeType needs some corrections.  It should require that somewhere in the tree it has specific styles. It will notify you at run time.
 *  Required types:
 *  background: ViewStyle,
    text: TextStyle,
    textItalic: TextStyle,
    textBold: TextStyle,
    More to come.
 */

const darkExtensions: ThemeTreeType = {
  background: {
    style: {backgroundColor: 'black'},
  },
  text: {
    style: {color: '#CCEEEE'}
  },
  style: {}
}

export var defLightTheme: ThemeTreeType = {
  style: {},
  background:{
    style: { backgroundColor: 'white' },
  },
  text:{
    style: {color: '#112222', fontFamily: 'sans-serif-medium' },
    textItalics: {
      style: { fontStyle: 'italic' }
    },
    textBold: {
      style: { fontWeight: "900" }
    },
    textHighlight: {
      style: { fontWeight: "700" }
    }
  }
} 

export const defDarkTheme = _.values(_.merge(defLightTheme, darkExtensions));
